import { render, staticRenderFns } from "./DriverRankCard.vue?vue&type=template&id=87366468&scoped=true&"
import script from "./DriverRankCard.vue?vue&type=script&lang=js&"
export * from "./DriverRankCard.vue?vue&type=script&lang=js&"
import style0 from "./DriverRankCard.vue?vue&type=style&index=0&id=87366468&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87366468",
  null
  
)

export default component.exports